import { useNavigate, useRouteContext, useSearch } from "@tanstack/react-router";
import { CircleCheck, Wallet } from "@repo/icons";
import {
  MessageDrawerRoot,
  MessageDrawerTitle,
  MessageDrawerBody,
  MessageDrawerActions,
  MessageDrawerActionButton,
} from "@/components/message-drawer";
import { trackEvent } from "@/lib/tracking";

interface CreatedAppointmentDrawerProps {
  setOpen: (open: boolean) => void;
}

export const ScheduledAppointmentDrawer = ({
  setOpen,
}: CreatedAppointmentDrawerProps): JSX.Element => {
  const searchParams: { action: "success" | "error"; codAgendamento: number } = useSearch(
    { strict: false },
  );

  const navigate = useNavigate();

  const { flags } = useRouteContext({
    strict: false,
  });

  const shouldRedirectToCreatePayment =
    flags[
      "exibe-botao-de-criar-pagamento-antecipado-no-drawer-de-agendamento-confirmado"
    ];

  const handleActionButtonClick = (): void => {
    if (shouldRedirectToCreatePayment) {
      trackEvent("Botão de pagamento clicado apos marcacao de agendamento", {
        codAgendamento: searchParams.codAgendamento,
      });

      void navigate({
        to: "/settings/payments/create",
        search: {
          appointmentId: searchParams.codAgendamento,
          origin: "pre",
          from: "appointment-created",
        },
      });
      return;
    }

    setOpen(false);
  };

  return (
    <MessageDrawerRoot
      open={searchParams.action === "success"}
      setOpen={setOpen}
      icon={CircleCheck}
      variant="secondary"
    >
      <MessageDrawerTitle>Agendamento marcado</MessageDrawerTitle>
      <MessageDrawerBody>
        O paciente receberá um e-mail com os dados do agendamento.
      </MessageDrawerBody>
      <MessageDrawerActions>
        {shouldRedirectToCreatePayment ? (
          <MessageDrawerActionButton
            color="secondaryLight"
            Icon={Wallet}
            className="text-secondary-400 hover:text-secondary-400 fill-secondary-400"
            onClick={handleActionButtonClick}
          >
            Criar pagamento antecipado
          </MessageDrawerActionButton>
        ) : (
          <MessageDrawerActionButton onClick={() => setOpen(false)}>
            Ir para minha agenda
          </MessageDrawerActionButton>
        )}
      </MessageDrawerActions>
    </MessageDrawerRoot>
  );
};
